import { useMemo, useState } from "react";
import { getBreakpoint, getBreakpointGap } from "../scss";
import { useResize } from "./hooks/resize";

/**
 * The function `createBreakpoint` returns a boolean value indicating whether a specific breakpoint has
 * been hit based on the window width.
 * @param bName - The `bName` parameter in the `createBreakpoint` function is a string that represents
 * the name of the breakpoint. It is used to retrieve the specific breakpoint and breakpoint gap values
 * from the `getBreakpoint` and `getBreakpointGap` functions respectively.
 * @returns The `createBreakpoint` function returns a boolean value indicating whether the current
 * window width is greater than or equal to the specified breakpoint value plus twice the breakpoint
 * gap value.
 */
const createBreakpoint =
  (bName) =>
  (defaultValue = false) => {
    const [hit, setHit] = useState(defaultValue);
    const breakpoint = useMemo(
      () => Number(getBreakpoint(bName)?.replace("px", "")),
      [],
    );
    const breakpointGap = useMemo(
      () => Number(getBreakpointGap(bName)?.replace("px", "")),
      [],
    );
    useResize(() => {
      setHit(window.innerWidth >= breakpoint + breakpointGap * 2);
    }, true);
    return hit;
  };

export const useBreakXS = createBreakpoint("xs");
export const useBreakSM = createBreakpoint("sm");
export const useBreakMD = createBreakpoint("md");
export const useBreakLG = createBreakpoint("lg");
export const useBreakXL = createBreakpoint("xl");
